import { FacadeMeasuresSubTable } from "./FacadeMeasuresSubTable";
import { FrameMeasuresSubTable } from "./FrameMeasuresSubTable";
import { FloorMeasuresSubTable } from "./FloorMeasuresSubTable";
import { RoofInsulationMeasuresSubTable } from "./RoofInsulationMeasuresSubTable";
import { VentilationMeasuresSubTable } from "./VentilationMeasuresSubTable";
import { HeatingMeasuresSubTable } from "./HeatingMeasuresSubTable";

export function EnergyMeasureTable() {
  return (
    <>
      <FacadeMeasuresSubTable />
      <FrameMeasuresSubTable />
      <FloorMeasuresSubTable />
      <RoofInsulationMeasuresSubTable />
      <VentilationMeasuresSubTable />
      <HeatingMeasuresSubTable />
    </>
  );
}
